"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Surface = void 0;
var _react = _interopRequireDefault(require("react"));
var _utility = require("../utility");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Surface = function Surface(props) {
  var children = props.children,
    _props$name = props.name,
    name = _props$name === void 0 ? 'surface-flat' : _props$name,
    className = props.className,
    width = props.width,
    height = props.height,
    id = props.id,
    interactive = props.interactive,
    surfaceClassName = props.surfaceClassName,
    _props$hasStates = props.hasStates,
    hasStates = _props$hasStates === void 0 ? false : _props$hasStates,
    events = props.events,
    active = props.active,
    _props$tabIndex = props.tabIndex,
    tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
    ariaAttributes = props.ariaAttributes;
  var surfaceClassNamePlaceHolder = surfaceClassName || "tl-".concat(name);
  var attributes = _objectSpread({}, ariaAttributes);
  if (hasStates) {
    attributes = _objectSpread(_objectSpread({}, attributes), events);
  }
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _utility.classNames)('tl-surface-container', className, hasStates ? 'tl-surface-stateful' : '', active && '--active'),
    tabIndex: tabIndex,
    id: id
  }, attributes), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(surfaceClassNamePlaceHolder, " ").concat(interactive ? 'tl-surface-non-interactive' : ''),
    style: {
      width: width,
      height: height
    }
  }, children));
};
exports.Surface = Surface;